module.exports = __webpack_public_path__ + "img/money.50cbfa84.png";